<template>
  <div class="page-wrapper">
    <div class="page-content--bge5">
      <div class="container">
        <div class="login-wrap">
          <div class="login-content" v-if="!finished">
            <div class="login-logo">
              <img alt="" src="/images/logo.png" class="sidebar-logo">
            </div>
            <div class="login-form">
              <div class="text-center m-b-20" style="color: red;" v-if="error">{{ error }}</div>
              <h6 class="title-5 m-b-20">enter your new password below</h6>
              <form @submit.prevent="onSubmit">
                <div class="form-group">
                  <label for="password">New password*</label>
                  <input
                    @blur="$v.form.password.$touch()"
                    autocomplete="new-password"
                    class="au-input au-input--full"
                    id="password"
                    placeholder="Enter Password"
                    type="password"
                    v-model="form.password">
                  <small
                    class="form-text text-danger"
                    v-if="$v.form.$error && !$v.form.password.required">This field must not be empty
                  </small>
                  <small
                    class="form-text text-danger"
                    v-else-if="$v.form.$error && !$v.form.password.min">Password must be at least 6 characters
                  </small>
                </div>
                <div class="form-group">
                  <label for="confirm-password">Re-enter new password*</label>
                  <input
                    @blur="$v.form.confirmedPassword.$touch()"
                    autocomplete="new-password"
                    class="au-input au-input--full"
                    id="confirm-password"
                    placeholder="Repeat password"
                    type="password"
                    v-model="form.confirmedPassword">
                  <small
                    class="form-text text-danger"
                    v-if="$v.form.$error && !$v.form.confirmedPassword.sameAs">The passwords do not match
                  </small>
                </div>
                <button class="au-btn au-btn--block au-btn--green m-b-20" type="submit">
                  <span class="spinner-border spinner-grow-sm" style="margin-bottom: 4px; margin-right: 4px;"
                        v-if="isLoaded"></span>
                  Change my password
                </button>
              </form>
              <div class="register-link">
                <p>
                  <router-link :to="{name: 'SignIn'}" tag="a">Sign In</router-link>
                </p>
              </div>
            </div>
          </div>

          <div class="card border border-success" v-if="finished">
            <div class="card-header">
              <strong class="card-title">Password Updated</strong>
            </div>
            <div class="card-body">
              <p class="card-text au-alert"><i class="zmdi zmdi-check-circle"></i>Your password has been updated
                successfully.
              </p>
              <div class="register-link">
                <p>
                  <router-link :to="{name: 'SignIn'}" tag="a">Go to Sign In</router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { minLength, required, sameAs } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      form: {
        password: '',
        confirmedPassword: '',
      },
      error: '',
      finished: false,
      isLoaded: false,
    };
  },
  validations: {
    form: {
      password: {
        required,
        min: minLength(6),
      },
      confirmedPassword: {
        sameAs: sameAs('password'),
      },
    },
  },
  created() {
    const code = this.$route.params.code;
    const formData = {
      ack: code,
    };
    this.$store.dispatch('passwordResetFinish', formData)
      .catch((errorMsg) => {
        if (errorMsg === 'invalid password reset ack') {
          this.$router.push({ name: 'SignIn' });
        }
      });
  },
  methods: {
    onSubmit() {
      this.error = '';
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;

      const formData = {
        ack: this.$route.params.code,
        password: this.form.password,
      };

      this.isLoaded = true;
      this.$store.dispatch('passwordResetFinish', formData)
        .then(() => {
          this.finished = true;
        })
        .catch((errorMsg) => {
          this.error = errorMsg;
        })
        .finally(() => {
          this.isLoaded = false;
        });
    },
  },
};
</script>

<style scoped>
  .invalid label {
    color: red;
  }
</style>
